import React from 'react';

const shortcutLabel = window.navigator.userAgent.includes('Mac') ? '⌘K' : 'Ctrl+K';

interface Props {
    onNodeLibraryButtonClick: () => void;
}

export const ShowNodeLibraryButton: React.FC<Props> = ({ onNodeLibraryButtonClick }) => {
    return (
        <button
            onClick={onNodeLibraryButtonClick}
            title={`Open Block Library (Tab or ${shortcutLabel})`}
            className="absolute bottom-6 right-6 pointer-events-auto w-[52px] h-[52px] rounded-2xl backdrop-blur-md bg-white/80 dark:bg-neutral-900/80 border border-white/30 dark:border-neutral-700/50 shadow-lg flex items-center justify-center transition-all hover:shadow-xl hover:scale-105 active:scale-95 cursor-pointer"
        >
            <svg
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-neutral-700 dark:text-neutral-200"
            >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
        </button>
    );
};
